import { Checkbox, Drawer, message, Spin } from "antd";
import closeIcon from "assets/closeIconWhite.png";
import "../register/customize.css";
import { useRechargeModel } from "./util";
import "./customize.css";
import styled from "@emotion/styled";
import { GiftContent, TipContent } from "./contant";
import { getLanguage } from "auth-provider";
import { LabelType, PageHeader } from "../register/page-header";
import { useReducer, useState, useCallback, useEffect, useRef, useMemo } from "react";
import { DisplayText, ThemeText } from "components/lib";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { LinkText } from "screens/register/page-register";
import backIcon from "assets/backIcon.png";
import coverBg from "assets/coverBg.png";
import { RestaurantConfig } from "screens/register/contant";
import { LinkArrow } from "./resturant-notify";
import { PayButton } from "./pay-button";
import { v4 as uuidv4 } from "uuid";
import { POS_API_URL, useHttp } from "utils/http";
import { useAuth } from "context/auth-context";
import { LoyaltyMember, Recharge } from "./reataurant-card";
import { LoadingOutlined } from "@ant-design/icons";
import { getHeaders, POS_HEADERS } from "utils/request";
import { PayAgreement } from "./pay-agreement";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import React from "react";
import { getLoyaltyMemberJoinStatus } from "utils";
import { JoinMemberMode, RechargeType } from "types/joinAsMemberMode";

export type GuestInfo = {
  name: string;
  id: string;
  phone: string;
  avatar: string;
  loyalty_member_id: string;
  email: string;
};

function getRechargeAvailableRestrictDaysDesc(lang: LabelType, recharge_available_restrict_days: number) {
  if (recharge_available_restrict_days) {
    return <React.Fragment>
      {
        lang === 'en' && <React.Fragment>
          {`Credits will be available after `}
          <span style={{ color: '#E00051' }}>&nbsp;{recharge_available_restrict_days}&nbsp;</span>
          {' days'}
        </React.Fragment>
      }
      {
        lang === 'zh' && <React.Fragment>
          {`充值金额`}
          <span style={{ color: '#E00051' }}>{recharge_available_restrict_days}</span>
          {'天后可用'}
        </React.Fragment>
      }
    </React.Fragment>
  } else {
    return <React.Fragment>
      {
        lang === 'en' && 'Recharge will not expire'
      }
      {
        lang === 'zh' && '充值不会过期'
      }
    </React.Fragment>;
  }
}

export const DrawGift = ({
  refresh,
  ...props
}: {
  setPayStatus: (val: string, rechargeType: RechargeType) => void;
  changeLang: (val: LabelType) => void;
  rechargeList: Recharge[];
  maxAmount: number;
  refresh: number;
  restaurantInfo: { phoneNumber: string; memeberId: string; username: string };
  loyaltyMember: LoyaltyMember;
}) => {
  const client = useHttp();
  const trackCommonData = useTrackCommonData();

  const lang = getLanguage() as LabelType;

  const { restaurant: restaurantData, disountData, restaurantGroupInfo } = useAuth();

  const [readStatus, setReadStatus] = useState(true);
  const [rechargeId, setRechargeId] = useState("");
  const [isCreateLoading, setIsCreate] = useState(false);
  const [reCount, setReCount] = useState(0);

  const [curOrderId, setOrderId] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [curOrderAmount, setOrderAmount] = useState(0);
  const [orderNumber, setOrderNumber] = useState('');
  const [msgCount, setMsgCount] = useState(0);
  const [bottomVisible, setBottomVisible] = useState(true);
  const [sHeight, setSHeight] = useState(0);

  const contentRef = useRef(null);
  const lastBtnRef = useRef(null);

  const { reCharge, forAnnual, closeRecharge, openRecharge } = useRechargeModel();
  const [rechargeJoinAsMemberMode, setRechargeJoinAsMemberMode] = useState(false);

  let { joinMemberMode, memberIsActive, rechargeJoinModeActived } = useMemo(() => {
    return getLoyaltyMemberJoinStatus(props.loyaltyMember, disountData);
  }, [props.loyaltyMember, disountData]);


  useEffect(() => {
    // if ((annualJoinModeActived || annualJoinModeExpiredActived) && forAnnual && joinMemberMode === JoinMemberMode.annual_fee_join) {
    if (joinMemberMode === JoinMemberMode.recharge_join && !memberIsActive) {
      setRechargeJoinAsMemberMode(true);
    }
    // eslint-disable-next-line
  }, [rechargeJoinModeActived, memberIsActive])


  const handleClose = () => {
    if (reCharge === "agreement") {
      openRecharge("open", forAnnual);
    } else {
      setRechargeId("");
      closeRecharge();
    }
  };

  const closeDialog = () => {
    trackMixPanel(MIX_PANEL_EVENT.PREPAY_CLOSE, trackCommonData);
    handleClose();
  };

  const resetData = useCallback(() => {
    setRechargeId("");
    setIsCreate(false);
    setOrderAmount(0);
  }, []);

  const [guestInfo, disGuestInfo] = useReducer(
    (state: GuestInfo, action: Partial<GuestInfo>) => ({ ...state, ...action }),
    {
      name: "",
      id: "",
      phone: "",
      avatar: "",
      loyalty_member_id: "",
      email: "",
    }
  );

  useEffect(() => {
    // 清空选项
    resetData();
  }, [refresh, resetData, reCount]);

  const handleChangeCheck = (e: CheckboxChangeEvent) => {
    const agreementStatus = e.target.checked || false;
    setReadStatus(agreementStatus);
  };

  const handleClickAgreement = () => {
    openRecharge("agreement", forAnnual);
  };

  const handleSelPlan = (id: string | undefined) => {
    if (isCreateLoading || !id || id === rechargeId) return;
    setRechargeId(id);
    createPayOrder(id);
    trackMixPanel(MIX_PANEL_EVENT.PREPAY_CLICK_PAY_LIST, trackCommonData);
  };

  const setUuid = () => {
    const orderId = uuidv4();
    const guestId = uuidv4();
    const paymentId = uuidv4();

    setPaymentId(paymentId);

    return {
      orderId,
      guestId,
    };
  };

  const createPayOrder = async (deal_id: string) => {
    try {
      // 创建pay order 时，下面加上遮罩
      const restaurantInfo = props.restaurantInfo;
      const { orderId, guestId } = setUuid();
      const guestInfoTmp = {
        name: restaurantInfo.username,
        id: guestId,
        phone: restaurantInfo.phoneNumber,
        avatar: "", // 无
        loyalty_member_id: restaurantInfo.memeberId,
        email: "", // 无
      };
      disGuestInfo(guestInfoTmp);
      // todo： 这里要加 try catch
      setIsCreate(true);
      const result = await client(`${POS_API_URL}/api/v1/order/${orderId}`, {
        method: "post",
        headers: getHeaders(POS_HEADERS),
        data: {
          deal_id: deal_id,
          id: orderId,
          service_type: "other", // 是否固定
          restaurant_id: restaurantData.data.id,
          order_source: "loyalty", // 是否正确
          guests: [guestInfoTmp],
          ... (restaurantGroupInfo ? {
            restaurant_group_id: restaurantGroupInfo.id,
          } : {})
        },
      });
      setIsCreate(false);
      // 获取需要支付的值，给stripe
      if (result?.total) {
        setOrderId(result.id);
        setOrderAmount(result.total);
        setOrderNumber(result.order_number);
        return;
      }
    } catch (error) {
      // 支付接口错误，给出提示
      message.error(TipContent.errorTip[lang]);
      setRechargeId("");
      setIsCreate(false);
      setOrderAmount(0);
    }
  };

  const checkStatusMsg = useCallback(() => {
    if (!readStatus) {
      if (!msgCount) {
        message.info(TipContent.unread[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return false;
    } else if (!rechargeId) {
      if (!msgCount) {
        message.info(TipContent.unsel[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return false;
    } else if (curOrderAmount <= 0) {
      if (!msgCount) {
        message.info(TipContent.amountError[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return false;
    } else {
      return true;
    }
  }, [readStatus, rechargeId, lang, msgCount, curOrderAmount]);

  // 获取高度
  const getHeight = () => {
    const ele = contentRef.current;
    if (!ele) {
      return;
    }
    // scrollHeight vs clientHeight
    const sHeight = (ele as HTMLDivElement).scrollHeight;
    const cHeight = (ele as HTMLDivElement).clientHeight;

    setSHeight(cHeight);
    setBottomVisible(sHeight - cHeight > 0);
  };

  useEffect(() => {
    setBottomVisible(false);
  }, [props.rechargeList, reCharge]);

  // Update 'width' and 'height' when the window resizes
  useEffect(() => {
    window.addEventListener("resize", getHeight);
    return () => {
      window.removeEventListener("resize", getHeight);
    };
  }, []);

  const handleScroll = (e: any) => {
    const difference =
      e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
    if (difference > 2) {
      if (!bottomVisible) {
        setBottomVisible(true);
      }
    } else {
      if (bottomVisible) {
        setBottomVisible(false);
      }
    }
  };

  const recharge_available_restrict_days = useMemo(() => {
    if (disountData) {
      return disountData.recharge_available_restrict_days || 0;
    }
    return 0;
  }, [disountData]);

  return (
    // forceRender={true} 解决useForm无元素挂载的问题
    <Drawer
      forceRender={false}
      visible={!!reCharge && !!!forAnnual}
      placement={"bottom"}
      width={"100vw"}
      height={'100%'}
      closable={false}
      style={{ padding: 0, borderRadius: "1.2rem 1.2rem 0 0" }}
      bodyStyle={{ padding: 0 }}
      className={`drawClass`}
    >
      <DrawTitle>
        <PageHeader
          changeLang={props.changeLang}
          styleObj={{ padding: 0, borderBottom: "none" }}
        >
          {reCharge === "agreement" ? (
            <LinkArrow onClick={handleClose}>
              <img
                src={backIcon}
                alt={"back png"}
                style={{
                  width: "0.6rem",
                  height: "1.4rem",
                  marginRight: "1.3rem",
                }}
              />
              <ThemeText fontWieght={500}>
                {RestaurantConfig.title?.[lang]}
              </ThemeText>
            </LinkArrow>
          ) : (
            <CloseOutlinedBox src={closeIcon} onClick={closeDialog} />
          )}
        </PageHeader>
      </DrawTitle>
      {reCharge === "open" && (
        <div className={"body-content"}>
          {
            <>
              <ContentTxt>
                {!!props.maxAmount
                  ? GiftContent.title[lang]
                  : GiftContent.rechargeZero[lang]}
              </ContentTxt>
              <ChargeListWrap ref={contentRef} onScroll={handleScroll}>
                {props.rechargeList.map((values, index) => {
                  const payAmount = parseInt(values.recharge || "0");
                  const cashAmount = parseInt(values.back || "0");
                  // const totalAmount = payAmount + cashAmount;
                  const isSel = values.reChargeId === rechargeId;
                  const isLast = index === props.rechargeList.length - 1;
                  return (
                    <RectangleBtn
                      onClick={() => handleSelPlan(values.reChargeId)}
                      isSel={isSel}
                      key={index}
                      isLast={isLast}
                      ref={isLast ? lastBtnRef : null}
                    >
                      <span>{`${GiftContent.tipBefore[lang]}$${payAmount}`}</span>
                      <React.Fragment>
                        {
                          cashAmount !== 0 && <React.Fragment>
                            <span>{","}&nbsp;</span>
                            <span
                              style={isSel ? { color: "#E00051" } : {}}
                            >{`${GiftContent.tipAfter[lang]}$${cashAmount}${GiftContent.tipAfterTail[lang]}`}</span>
                          </React.Fragment>
                        }
                      </React.Fragment>

                    </RectangleBtn>
                  );
                })}
                {
                  recharge_available_restrict_days > 0 && <RechargeAvailableRestrictDaysDescSpan>
                    {getRechargeAvailableRestrictDaysDesc(lang, recharge_available_restrict_days)}
                  </RechargeAvailableRestrictDaysDescSpan>
                }
                {bottomVisible && (
                  <BottomWrap src={coverBg} topVal={sHeight + "px"}></BottomWrap>
                )}
              </ChargeListWrap>

            </>
          }


          {/* 在创建时，加透明度，并且给个loading */}

          <PayWrapBox isLoading={isCreateLoading}>
            {isCreateLoading && (
              <LoadingWarpper>
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: "3.6rem", color: "#fff" }}
                      spin
                    />
                  }
                  size={"large"}
                ></Spin>
              </LoadingWarpper>
            )}
            <PayButton
              lang={lang}
              orderId={curOrderId}
              orderAmount={curOrderAmount}
              guestInfo={guestInfo}
              paymentId={paymentId}
              orderNumber={orderNumber}
              setPayStatus={(val: string) => props.setPayStatus(val, rechargeJoinAsMemberMode ? RechargeType.join_member_recharge_fee : RechargeType.normal_gift_card_recharge)}
              closeDraw={() => handleClose()}
              checkStatusMsg={checkStatusMsg}
              refreshPay={() => setReCount((val) => val + 1)}
              getHeight={getHeight}
            ></PayButton>
          </PayWrapBox>
          {/* 阅读协议 */}
          <DisplayText marginVal={"1.6rem auto 0.8rem auto"}>
            <Checkbox
              checked={readStatus}
              onChange={handleChangeCheck}
              className={"checkClasses"}
            >
              <ThemeText
                fontColor={"#92929F"}
                fontSize={1.4}
                style={{ display: "inline-block" }}
              >
                {GiftContent.agreementBefore[lang]}
              </ThemeText>
              <LinkText onClick={() => handleClickAgreement()}>
                {GiftContent.agreementAfter[lang]}
              </LinkText>
            </Checkbox>
          </DisplayText>
        </div>
      )}
      {reCharge === "agreement" && <PayAgreement />}
    </Drawer>
  );
};

const DrawTitle = styled.div`
  height: 4.6rem;
  line-height: 4.6rem;
  width: 100%;
  margin-bottom: 1.2rem;
`;

const CloseOutlinedBox = styled.img`
  width: 3.6rem;
  height: 3.6rem;
`;

const ContentTxt = styled.div`
  color: #fff;
  font-weight: 400;
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.6rem;
  height: 1.8rem;
`;

const PayWrapBox = styled.div<{
  isLoading: boolean;
}>`
  position: relative;
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;

const BaseBtn = styled.div`
  height: 5.6rem;
  width: 100%;
  border: 1px solid #fff;
  border-radius: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
`;

const RectangleBtn = styled(BaseBtn) <{
  isSel?: boolean;
  isLast: boolean;
}>`
  background: ${(props) => (props.isSel ? "#ffffff" : undefined)};
  color: ${(props) => (props.isSel ? "#000000" : "#ffffff")};
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: ${(props) => (props.isLast ? "3rem" : "1.5rem")};
`;

const LoadingWarpper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChargeListWrap = styled.div`
  overflow: auto;
  margin-bottom: auto;
`;




// 8 - 3.4
const BottomWrap = styled.img<{
  topVal: string;
}>`
  position: absolute;
  top: ${(props) => `calc(${props.topVal} - 4.6rem)`};
  height: 8rem;
  width: 100%;
`;

const RechargeAvailableRestrictDaysDescSpan = styled.span`
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 18px;
display:flex;
align-items: center;
justify-content: center;
color: #ffffff;
padding: 8px 10px;
border: 2px solid #e00051;
width: max-content;
margin: 0 auto;
border-radius: 5px;
line-height: 1.5;
`;




